import React, { FC } from "react";
import { useFormContext } from "react-hook-form";
import TGButton from "src/components/ui/TGButton";

interface IProps {
  openModalAddTest: () => void;
  testsList: any[];
}

export const TestRegistryListFooter: FC<IProps> = ({ openModalAddTest, testsList }) => {
  const { watch } = useFormContext();

  const selectedTestID = watch("TestID");

  return (
    <div className="flex items-center justify-between px-9 pb-9">
      <TGButton type="button" onClick={openModalAddTest}>
        Отмена
      </TGButton>
      <TGButton onClick={openModalAddTest} type="submit" color="bluedark" disabled={!testsList.length || !selectedTestID}>
        Выбрать
      </TGButton>
    </div>
  );
};
